module.exports = {"cn":{"title":"账号申请","desc":"申请已提交，请耐心等待审批！","back":"返回首页"},"en":{"title":"Account Application","desc":"The application has been submitted, please wait patiently for approval!","back":"Back to homepage"}}


//////////////////
// WEBPACK FOOTER
// ./src/js/succful.json
// module id = M/xY
// module chunks = 1